import "../styles/style.css"; // Import global styles

import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import useGalleryModal from "../hooks/useGalleryModal";
import Gallery from "../components/Gallery";

const Art = () => {
  const { isOpen, data, openFromElement, close, next, prev } = useGalleryModal();
  // Static list, no async updates
  const AVAILABLE_CATS: string[] = [
    'all',
    'landscape',
    'markets & crowds',
    'plants',
    'portrait',
    'sketchbook',
    'still life',
  ];
  const [filter, setFilter] = useState<string>('all');

  return (
    <>
      <Header />
      <main>
        <div className="gallery-filter">
          {AVAILABLE_CATS.map((cat) => (
            <button
              key={cat}
              className={`filter-btn${filter === cat ? ' active' : ''}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
        <div className="art-gallery">
          <Gallery
            showMetadata={false}
            useMacy={true}
            onItemClick={(_, el) => openFromElement(el)}
            categoryFilter={filter}
          />
        </div>

        {isOpen && (
          <div className="modal" style={{ display: 'flex' }} onClick={(e) => { if (e.currentTarget === e.target) close(); }}>
            <div className="modal-content" style={{ position: 'relative' }}>
              <button className="modal-close" aria-label="Close" onClick={close}>&times;</button>
              {/* Prev / Next controls */}
              <button className="modal-close modal-arrow prev" aria-label="Previous" onClick={prev}>‹</button>
              <button className="modal-close modal-arrow next" aria-label="Next" onClick={next}>›</button>

              {data?.imgSrc && <img id="modalImg" src={data.imgSrc} alt={data?.imgAlt || ''} />}
              <h3 id="modalTitle">{data?.title}</h3>
              <div id="modalDetails">
                {data?.details?.map((d, i) => (
                  <div key={i}>{d}</div>
                ))}
              </div>
            </div>
          </div>
        )}
      </main>
      <hr style={{ border: 'none', borderTop: '1px solid #ccc' }} />
      <Footer />
    </>
  );
};

export default Art;
